import { render, staticRenderFns } from "./ProductsTabAccordian.vue?vue&type=template&id=4741efd8&scoped=true&"
import script from "./ProductsTabAccordian.vue?vue&type=script&lang=js&"
export * from "./ProductsTabAccordian.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTabAccordian.vue?vue&type=style&index=0&id=4741efd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741efd8",
  null
  
)

export default component.exports